import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
export var ManagementTrainers;
(function (ManagementTrainers) {
    ManagementTrainers.Schema = z.object({
        userId: z.string(),
        email: z.string().email(),
        calendarColor: z.string(),
        nickname: z.string()
    });
    ;
    const relationships = {};
    function Defaults() {
        return {
            userId: "",
            email: "",
            calendarColor: "",
            nickname: ""
        };
    }
    ManagementTrainers.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships = relationships;
        defaults = Defaults;
    }
    ManagementTrainers.CollectionClass = CollectionClass;
    ManagementTrainers.Collection = new CollectionClass({ path: "/ManagementTrainers" });
})(ManagementTrainers || (ManagementTrainers = {}));
//# sourceMappingURL=index.js.map